import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as InformationAction from 'store/actions/information';
import * as CustomClearenceAction from 'store/actions/customClearence';
import * as FinanceService from 'services/finance';
import * as EmployeeAction from 'store/actions/employee';
import { Button } from 'reactstrap';
import List from './list';
import { customRound } from 'utli';
import AddDialog from './../addDialog';
import DeleteAllConfirm from './deleteAllConfirm';
import DetailDialog from './detailDialog';
// import WaybillLabelExport from '../WaybillLabelExport';
import ConfirmDialog from 'components/Dialogs/ConfirmDialog';
// import PrintButton from '../A5PrintComponent';
import useViewPermission from 'hooks/useViewPermission';
import FilterBox from './filter';
import * as WaybillAction from 'store/actions/waybill';
// import * as WaybillService from 'services/waybill';
import { useHistory } from 'react-router';
import queryString from 'query-string';
import { NotificationManager } from 'react-notifications';
import { t } from 'i18next';
import useActionPermission from 'hooks/useActionPermission';
import PrintDialog from '../printDialog';
import PrintButton from '../A5PrintComponent';
import WaybillLabelExport from '../WaybillLabelExport';

function WaybillQueryContent({ saleReport = false }) {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const [showDelete, setShowDelete] = React.useState(false);
  const [showDetail, setShowDetail] = React.useState(false);
  const [showDeleteAll, setShowDeleteAll] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState(null);
  const [selectedData, setSelectedData] = React.useState([]);
  const [searchType, setSearchType] = React.useState('waybillnumber');
  const [search, setSearch] = React.useState();
  const [dateSearch, setDateSearch] = React.useState();
  const { canEdit, canDelete } = useActionPermission('document');
  const { isOwn, isBranch } = useViewPermission(!saleReport ? 'document' : 'sale_report');

  const dispatch = useDispatch();
  const router = useHistory();

  const waybills = useSelector((state) => state.waybill.waybills);
  const waybills_report = useSelector((state) => state.waybill.waybills_report);

  const actionLoading = useSelector((state) => state.loading.actionLoading);

  const [openPrintDialog, setOpenPrintDialog] = React.useState(false);
  const onPrintTogglae = (e) => {
    console.log(e);
    setEditData(e);
    setOpenPrintDialog(!openPrintDialog);
  };

  const headers = [
    // {
    //   text: '',
    //   width: 40,
    //   className: 'fixed-cell left',
    // },

    {
      text: 'waybill_entry.waybill',
      className: 'fixed-cell left',
      // left: 55,
    },
    {
      text: 'waybill_entry.shipping_date',
      // className: 'fixed-cell left',
      left: 160,
    },
    {
      text: 'waybill_entry.shipment_type',
    },
    {
      text: 'waybill_entry.shipping_mode',
    },
    {
      text: 'waybill_entry.quotation_no',
    },
    {
      text: 'waybill_entry.license_no',
    },
    {
      text: 'waybill_entry.delivery_place',
    },
    {
      text: 'waybill_entry.destination',
    },
    {
      text: 'address_book.code',
    },
    {
      text: 'waybill_entry.sender_company',
    },
    {
      text: 'address_book.sender',
    },
    {
      text: 'address_book.phonenumber',
    },
    {
      text: 'waybill_entry.receiver_company',
    },
    {
      text: 'address_book.receiver',
    },
    {
      text: 'address_book.phonenumber',
    },
    {
      text: 'waybill_entry.cargo_type',
    },
    {
      text: 'waybill_entry.item_type',
    },
    {
      text: 'waybill_entry.item_name',
    },
    {
      text: 'waybill_entry.qty',
    },
    {
      text: 'waybill_entry.weight',
    },
    {
      text: 'waybill_entry.volume',
    },
    {
      text: 'waybill_entry.value',
    },
    {
      text: 'waybill_entry.remark',
    },
    {
      text: 'waybill_entry.paymentCurrency',
    },
    {
      text: 'waybill_entry.total',
    },
    {
      text: 'finance.remaining_balance',
    },
    {
      text: 'waybill_entry.paymentCurrency',
    },
    {
      text: 'waybill_entry.total',
    },
    {
      text: 'finance.remaining_balance',
    },
    {
      text: !saleReport ? 'waybill_entry.operator' : 'waybill_entry.sale_person',
      // className: 'fixed-cell',
      right: 180,
    },
    {
      text: 'waybill_entry.order_date',
      // className: 'fixed-cell',
      right: 80,
    },
    {
      text: 'waybill_entry.status',
      // className: 'fixed-cell',
      right: 0,
    },
    {
      text: 'actions',
      className: 'fixed-cell',
      width: 400,
    },
  ];

  React.useEffect(() => {
    dispatch(InformationAction.getBranch());
    dispatch(EmployeeAction.getMarketingPerson());
    dispatch(CustomClearenceAction.getAll({}, true));
  }, [dispatch, InformationAction.getBranch, CustomClearenceAction.getAll]);

  React.useEffect(() => {
    loadData(searchValue);
  }, [WaybillAction.getAll, router.location.search]);

  const loadData = (value = null) => {
    setSearchValue(value);
    let query = { limit: 10, page: 1 };

    if (isOwn()) query.isOwn = !!isOwn();
    if (isBranch()) query.isBranch = !!isBranch();

    if (router.location.search) query = { ...query, ...queryString.parse(router.location.search) };

    if (saleReport) query.saleReport = true;

    dispatch(WaybillAction.getAll(query, value ? value : searchValue ? searchValue : {}));
  };

  const getTotal = (second_costinfo) => {
      if (second_costinfo) {
        let {
          prepaid_for_client,
          pickup_fee,
          clearence_fee,
          storage_fee,
          loading_fee,
          packaging_fee,
          agent_fee,
          basic_freight,
          insurance_fee,
        } = second_costinfo;
  
        let sum = 0;
        if (insurance_fee !== undefined) {
          if (insurance_fee > 0) sum += parseFloat(insurance_fee);
        }
        if (prepaid_for_client !== undefined) {
          if (prepaid_for_client > 0) sum += parseFloat(prepaid_for_client);
        }
        if (pickup_fee !== undefined) {
          if (pickup_fee > 0) sum += parseFloat(pickup_fee);
        }
        if (clearence_fee !== undefined) {
          if (clearence_fee > 0) sum += parseFloat(clearence_fee);
        }
        if (storage_fee !== undefined) {
          if (storage_fee > 0) sum += parseFloat(storage_fee);
        }
        if (loading_fee !== undefined) {
          if (loading_fee > 0) sum += parseFloat(loading_fee);
        }
        if (packaging_fee !== undefined) {
          if (packaging_fee > 0) sum += parseFloat(packaging_fee);
        }
        if (agent_fee !== undefined) {
          if (agent_fee > 0) sum += parseFloat(agent_fee);
        }
        if (basic_freight !== undefined) {
          if (basic_freight > 0) sum += parseFloat(basic_freight);
        }
  
        return customRound(sum.toFixed(1));
      }
    };

  return (
    <>
      <List
        saleReport
        headers={headers}
        onToggle={(e) => onPrintTogglae(e)}
        selectedData={selectedData}
        data={saleReport ? waybills_report : waybills}
        onDelete={async (data) => {
          let response = await FinanceService.getTranscationCount(data.waybillnumber);
          if (response.length > 0) {
            NotificationManager.error('This waybill has been used in transcation');
          } else {
            setShowDelete(true);
            setEditData(data);
          }
        }}
        canEdit={canEdit}
        canDelete={canDelete}
        onEdit={async (e) => {

          setEditData(e);
          setTimeout(() => {
            setModalOpen(true);
          }, 1000);

          // if (e.is_used) {
          //   NotificationManager.error(t('waybill_entry.already_used'));
          // } else {
          //   let response = await FinanceService.getTranscationCount(e.waybillnumber);
          //   if (response.length > 0) {
          //     NotificationManager.error('This waybill has been used in transcation');
          //   } else {
          //     setEditData(e);
          //     setTimeout(() => {
          //       setModalOpen(true);
          //     }, 1000);
          //   }
          // }
        }}
        onSelect={(e) => {
          if (selectedData.find((s) => s._id === e._id)) setSelectedData(selectedData.filter((s) => s._id !== e._id));
          else setSelectedData([...selectedData, e]);
        }}
        showDetail={(e) => {
          setShowDetail(true);
          setEditData(e);
        }}
        filter={
          <FilterBox
            searchType={searchType}
            setSearch={setSearch}
            search={search}
            isOwn={isOwn()?.status || false || isBranch()?.status || false}
            setSearchType={setSearchType}
            setDateSearch={setDateSearch}
            dateSearch={dateSearch}
            onSearch={(value) => {
              setSelectedData([]);
              loadData(value);
            }}
          />
        }
        buttons={
          <>
            {/* {canEdit() && (
              <Button
                style={{ width: 100 }}
                size='sm'
                disabled={selectedData.length === 0}
                onClick={async () => {
                  if (selectedData.length === 1) {
                    const transcations = await WaybillService.getTranscationWaybill(selectedData[0].waybillnumber);
                    if (transcations.length > 0) {
                      NotificationManager.error('This waybill has been used in transcation');
                    } else {
                      let cargoCountResponse = await WaybillService.getWaybillCargoCount(selectedData[0].waybillnumber);
                      if (cargoCountResponse > 0) {
                        NotificationManager.error('This waybill has been used in cargo');
                      } else {
                        setModalOpen(true);
                        setEditData(selectedData[0]);
                      }
                    }
                  } else {
                    NotificationManager.error('Please choose only one orwaybillder to edit');
                  }
                }}
              >
                <i className='fa fa-edit mr-2' /> {t('edit')}
              </Button>
            )} */}
            <Button
              style={{ width: 100 }}
              size='sm'
              disabled={actionLoading}
              onClick={() => {
                const query = {};
                if (isOwn()) query.isOwn = !!isOwn();
                if (isBranch()) query.isBranch = !!isBranch();
                if (saleReport) query.saleReport = true;
                dispatch(WaybillAction.exportData(searchValue ? { ...searchValue, ...query } : query));
              }}
            >
              {actionLoading ? <i className='fa fa-spinner mr-2' /> : <i className='fa fa-file-excel mr-2' />}
              {t('export')}
            </Button>
            {/* <PrintButton selectedData={selectedData} />
            <WaybillLabelExport selectedData={selectedData} /> */}
            <Button
              style={{ width: 100 }}
              size='sm'
              onClick={() => {
                if (saleReport) {
                  window.location = '/sale_report';
                  return;
                }
                window.location = '/waybill-query';
              }}
            >
              <i className='fa fa-spinner mr-2' /> {t('refresh')}
            </Button>
            {/* {canDelete() && (
              <Button
                style={{ width: 100 }}
                size='sm'
                disabled={selectedData.length === 0}
                onClick={() => {
                  setShowDeleteAll(true);
                }}
              >
                <i className='fa fa-trash mr-2' /> {t('delete')}
              </Button>
            )} */}
          </>
        }
      />
      <AddDialog
        title={editData ? `${t('edit')} ${t('waybill_entry.waybill')}` : `${t('add')} ${t('waybill_entry.waybill')}`}
        editData={editData}
        modalOpen={modalOpen}
        onToggle={(open) => setModalOpen(open)}
        onSubmit={(values, uploadFiles) => {

          setModalOpen(false);

          if (editData) {
            values.original_waybill_id = editData._id;
            values.waybillnumber = editData.basicinfo?.waybill_no;

            values.remaining_balance = editData.remaining_balance;
            console.log(values);
           

            const updatedTotal=getTotal(values?.second_costinfo);

        
            if (editData?.second_cost?.total === updatedTotal) {
              values.second_remaining_balance = editData.second_remaining_balance;
            }
          }

        

          dispatch(WaybillAction.save(values, uploadFiles, true));
          setSelectedData([]);
          setTimeout(() => loadData(), 1000);


        }
        }
      />
      <ConfirmDialog
        modalOpen={showDelete}
        title={`${t('delete')} ${t('waybill_entry.waybill')}`}
        body={`${t('confirm_delete')} ${editData?.waybillnumber}?`}
        onToggle={() => setShowDelete(false)}
        onConfirm={() => {
          setShowDelete(false);
          dispatch(WaybillAction.deleteAllData({ waybill_id_list: [editData?._id] }));
          setTimeout(() => loadData(), 1000);
        }}
      />
      <DeleteAllConfirm
        data={selectedData}
        modalOpen={showDeleteAll}
        title={`${t('delete')} ${t('waybill_entry.waybill')}`}
        body={`${t('confirm_delete')}?`}
        onToggle={() => setShowDeleteAll(false)}
        onConfirm={() => {
          setShowDeleteAll(false);
          setSelectedData([]);
          dispatch(WaybillAction.deleteAllData({ waybill_id_list: selectedData }));
          setTimeout(() => loadData(), 1000);
        }}
        onRemoveSelected={(e) => {
          setSelectedData(selectedData.filter((s) => s._id !== e._id));
        }}
      />
      <DetailDialog
        data={editData}
        modalOpen={showDetail}
        onToggle={() => setShowDetail(false)}
        customItemName={editData?.item?.itemtype?.name}
        customPaymentMethod={editData?.cost?.paymentType?.name}
      />
      <PrintDialog onToggle={onPrintTogglae} modalOpen={openPrintDialog}>
        <div style={{ textAlign: 'center' }}>
          <PrintButton selectedData={editData} />
          <h5>Print</h5>
        </div>
        <div style={{ textAlign: 'center' }}>
          <WaybillLabelExport selectedData={editData} />
          <h5>Label</h5>
        </div>
      </PrintDialog>
    </>
  );
}

export default WaybillQueryContent;
